module.exports = __webpack_public_path__ + "img/indexingecommerce.e33a36ab.png";